import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import PremiumThankYou from '../components/PremiumThankYou';

const SubmittedPage = () => {
  usePageMeta({
    title: 'Submission Received | BM-Assist.co',
    description: 'Your submission has been received. Our team will review it and follow up shortly.',
    ogTitle: 'Submission Received | BM-Assist.co',
    ogDescription: 'Thank you for your submission.'
  });

  const bulletPoints = [
    "We've received your submission and it's in our queue",
    "Our team will review the details within 24 hours",
    "You'll receive a follow-up email with next steps or pricing"
  ];

  return (
    <PremiumThankYou
      title="We Got It!"
      subtitle="Your submission has been received."
      bulletPoints={bulletPoints}
      primaryButtonText="Back to Home"
      primaryButtonLink="/"
      secondaryButtonText="Browse Services"
      secondaryButtonLink="/bundles"
    />
  );
};

export default SubmittedPage;
